export default __webpack_public_path__ + "static/media/karimi.5515120d.jpg";